module.exports = __webpack_public_path__ + "static/media/screen1.a7345df2.png";